<form #form="ngForm" class="simples-nacional-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Simples Nacional
            </h6>
            <p class="form-text text-muted">
                Dados do Simples Nacional da empresa
            </p>
        </div>  

        <div class="card-body" *ngIf="entity">
            <div class="row">
                <div class="form-group col-12">             
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.optanteSimplesNacional" name="optanteSimplesNacional" id="optanteSimplesNacional"
                            [disabled]="!canEdit" [readonly]="!canEdit">
                        <label class="custom-control-label" for="optanteSimplesNacional">
                            Optante pelo Simples Nacional?
                        </label>
                    </div>                    
                    <p class="form-text text-muted">
                        Marque esta opção se a empresa for optante pelo Simples Nacional
                    </p>                                           
                </div>                
            </div>
            <div class="row simples-nacional-datas">
                <div class="form-group col-12" [ngClass]="{'col-md': !isMini}"
                    *ngIf="canEdit || entity.optanteSimplesNacional">     
                    <label for="optanteSimplesNacionalData" class="control-label">Data de Opção pelo Simples Nacional</label>
                    <ng-template [ngIf]="canEdit && entity.optanteSimplesNacional">
                        <sgt-datepicker [(ngModel)]="entity.optanteSimplesNacionalData" name="optanteSimplesNacionalData" id="optanteSimplesNacionalData"
                            #optanteSimplesNacionalData="ngModel" [ngControl]="optanteSimplesNacionalData" #optanteSimplesNacionalDataDatepicker
                            [required]="entity.optanteSimplesNacional">
                        </sgt-datepicker>
                        <sgt-form-control-error
                            *ngIf="optanteSimplesNacionalData.errors && optanteSimplesNacionalData.errors.required && optanteSimplesNacionalData.dirty"
                            msgError="A data de opção pelo Simples Nacional é obrigatória">
                        </sgt-form-control-error> 
                    </ng-template>

                    <ng-template [ngIf]="!canEdit || !entity.optanteSimplesNacional">
                        <input type="text" class="form-control" [value]="entity.optanteSimplesNacionalData | date:'dd/MM/yyyy'" name="optanteSimplesNacionalData" id="optanteSimplesNacionalData"
                            disabled="disabled" readonly="readonly">
                    </ng-template>

                    <p class="form-text text-muted">
                        Data em que a empresa optou pelo Simples Nacional
                    </p>
                </div>

                <div class="form-group col-12" [ngClass]="{'col-md': !isMini}"
                    *ngIf="canEdit || entity.optanteSimplesNacionalDataExclusao">     
                    <label for="optanteSimplesNacionalDataExclusao" class="control-label">Data de Exclusão do Simples Nacional</label>
                    <ng-template [ngIf]="canEdit">
                        <sgt-datepicker [(ngModel)]="entity.optanteSimplesNacionalDataExclusao" name="optanteSimplesNacionalDataExclusao" id="optanteSimplesNacionalDataExclusao"
                            #optanteSimplesNacionalDataExclusao="ngModel" [ngControl]="optanteSimplesNacionalDataExclusao">
                        </sgt-datepicker>
                    </ng-template>

                    <ng-template [ngIf]="!canEdit">
                        <input type="text" class="form-control" [value]="entity.optanteSimplesNacionalDataExclusao | date:'dd/MM/yyyy'" name="optanteSimplesNacionalDataExclusao" id="optanteSimplesNacionalDataExclusao"
                            disabled="disabled" readonly="readonly">
                    </ng-template>

                    <p class="form-text text-muted">
                        Data em que a empresa foi excluída do Simples Nacional
                    </p>                    
                </div>
            </div>
        </div>
    </div>
</form>